import { yupResolver } from '@hookform/resolvers/yup';

import yup, { ErrorLengthMax, ErrorLengthMin } from 'utils/yup-form-validator';

const schema = yup.object({
  name: yup.string()
    .min(3, ErrorLengthMin(3)).max(48, ErrorLengthMax(48))
    .isAlphanumericHypenBracketSpace()
    .required(),
  addressType: yup.string().oneOf(['V4', 'V6']).required(),
  prefix: yup.string()
    .when('addressType', {
      is: 'V4',
      then: yup.string().ipv4WithCIDR().required(),
      otherwise: yup.string().ipv6WithCIDR().required(),
    }),
  first: yup.string().ipIsInSubnet('addressType', 'prefix').required(),
  last: yup.string().ipIsInSubnet('addressType', 'prefix').ipIsOver('addressType', 'first').required(),
  multicastInfos: yup.array(),
});

const validator = yupResolver(schema);

export default validator;
